import { useEffect, useState } from 'react';
import { PRESENCE_EVERY_MS, type PublicStatsReply } from '@london-life/contracts';
import { api } from '../lib/api';

// Says hello to the server once a minute while the page is open and visible (that is how "online" and
// "visits" are counted; nothing is stored on the device), and reads what the homepage should show.
export function useSiteStats() {
  const [stats, setStats] = useState<PublicStatsReply['stats'] | null>(null);
  useEffect(() => {
    let alive = true;
    // the first hello of this page open is a view
    let view = true;
    const tick = async () => {
      if (document.hidden) return;
      await api.presence({ view }).catch(() => {});
      view = false;
      const reply = await api.siteStats().catch(() => null);
      if (alive && reply) setStats(reply.stats);
    };
    void tick();
    const timer = window.setInterval(() => void tick(), PRESENCE_EVERY_MS);
    const visible = () => !document.hidden && void tick();
    document.addEventListener('visibilitychange', visible);
    return () => {
      alive = false;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', visible);
    };
  }, []);
  return stats;
}
